import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import {MatSnackBar} from '@angular/material/snack-bar';
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import {TranslateService} from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import { ProgramacionService } from "app/main/wizard-cgo/services/programacion.service";
import * as backInter from 'app/auth/auth-data.model';
import {RequirementsService} from 'app/main/pagina/tools/services/requirements.service';
import { SheduleService } from "app/main/pagina/certificar/services/shedule.service";
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import Swal from 'sweetalert2';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { SurveyStatusService } from "app/main/pagina/tools/survey-status/survey-status.service";
import { SurveyStatusV2Service } from "app/main/pagina/tools/survey-status-v2/survey-status-v2.service";
import { DATOS_API } from 'app/auth/auth.datos';
import { EditorEncuestaService } from "app/main/pagina/productos/certificar/tipo_2/editor-encuesta/editor-encuesta.service";

const moment = require('moment');

@Component({
  selector: 'visor-correos',
  templateUrl: './visor-correos.component.html',
  styleUrls: ['./visor-correos.component.scss']
})
export class VisorCorreosComponent implements OnInit {

  @ViewChild('pasos') pasos: MatStepper;

  enviaDatosEditor: Subject<any> = new Subject<any>();
  enviaDatosCorreos: Subject<any> = new Subject<any>();

  idEmpresa: string;
  idProducto: string;
  idProducto_tmp: any;

  opened = true;
  edicion = false;
  validacion = false;
  validacionReq : boolean;// Por default todos deben activar su requerimientos tenicos
  idiomaActual:string;
  tipoProducto:string="";
  validacionEncuesta=false;
  validarProductoFocus=false;
  instituto:any;
  switchsProrrogaCierre=true;
  numeroRecos: number;
  cierreActivado: boolean;
  opcRecos = [
    {valor: 1},{valor: 2},{valor: 3},{valor: 4},{valor: 5},
    {valor: 6},{valor: 7},{valor: 8},{valor: 9},{valor: 10},
    {valor: 11},{valor: 12},{valor: 13},{valor: 14},{valor: 15},
    {valor: 9999, nombre: 'CONSULTATABLA.EDITORMAILODS.ULTD'}
  ];
   idiomasRTSelect:any;
  prorroga:boolean=false;
  statusEdtitor:boolean=false;
  statusProrroga:boolean=false;
  desbloqueoActivar:boolean=false;
  // variable que permite ver los controles para certificar 3.0
  contenidoCertificarV3:boolean;


// variables booleans para la configuración de producto
  activarProrroga:boolean;
  actualizarFechaCierre:boolean;
  companyName4All:boolean;
  controlFlag:boolean;
  correosCierre:boolean;
  correosEnviados:boolean;
  desbloqueoPasos:boolean;
  edicionTemplates:boolean;
  editarCierre:boolean;
  isPin:boolean;
  mailRequerimientosv3:boolean;
  requerimientos:boolean;
  requerimientosv3:any={};
  resultsBoxRanking:boolean;
  resultsBoxEntregables:boolean;
  validadoTemplates:boolean;
  showInstructions:boolean;
  showUserName:boolean;
  showHelp:boolean;
  urlAssetsEmail= DATOS_API.urlAssets;
  tipoProductActionGo:boolean=false;
  tipoProductLeaderGo:boolean=false;

  datosBanderas: any;
  mostrarCloudNuevo: boolean;
  fechaNuevaVersion = "2021-09-28";
  textoCertificado: string;
  fechaPasoVoice = "2021-11-28";
  mostrarConfigVoiceSection: boolean;

  constructor(
    private activatedRoute : ActivatedRoute,
    private router: Router,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private programacionService: ProgramacionService,
    private _snackBar: MatSnackBar,
    private service :RequirementsService,
    private sheduleService: SheduleService,
    private translateSrv: TranslateService,
    private translate: TranslateService,
    private encuestaService: EncuestaService,
    private surveyServ: SurveyStatusService,
    private ees: EditorEncuestaService,
    private sssv: SurveyStatusV2Service
  ) {
    this.activatedRoute.params.subscribe(params => {
      //console.log('llego el parametro');
      console.log(params);
      this.idEmpresa = params.id;
      this.idProducto = params.idprod;
      this.idProducto_tmp=this.idProducto;
    });
    this.tipoProducto=localStorage.getItem('tipoProct');
    if (this.tipoProducto=="actionGo" || this.tipoProducto=="leader Go") {
      this.tipoProductActionGo=true;
    }else{
      this.tipoProductActionGo=false;
    }

    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    lang_shedule.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    /*lang_shedule.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });*/
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_idiomas.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

  }

  ngOnInit() {
    console.log(this.tipoProducto);
    const prods3_0 = [40, 41, 42, 43,63,56,57,58,75];
    if(prods3_0.includes(parseInt(localStorage.getItem('categoria')))){
      console.log("es el 3.0");

      this.contenidoCertificarV3=true;
    }else{
      console.log("No es el 3.0");
      this.contenidoCertificarV3=false;
    }
    this.instituto=localStorage.getItem('instituto_correos');
    console.log(this.instituto);
    if(this.instituto == '1'){
      this.prorroga=true;
      // this.switchsProrrogaCierre=false;
      console.log("entro para mx");
    }
    this.velidateBanderas();
    switch (this.tipoProducto) {
      case 'Focus Area':
      this.getStatusValidacionEncuesta();
      this.validarProductoFocus=true;
      if(localStorage.getItem('surveyToken') != undefined){
        this.getTextoCertificado(localStorage.getItem('surveyToken'));
      }
      break;
      case 'Norma35':
      this.getStatusBanderaProrrogas();

      break;

      default:
      this.getStatusBanderaProrrogas();
      this.getStatusPing();
      if(localStorage.getItem('surveyToken') != undefined){
        this.getTextoCertificado(localStorage.getItem('surveyToken'));
      }
      break;
    }

    this.getStatusEditor();
    this.getCierreActivo();
    this.statusDesbloqueo();
    // this.statusMostrarResuCerti();
    // this.getStatusPing();
    this.getBanderaConfiguracion();

    this.getInfoEmpresa();
    this.obtieneBanderasConfiguracion();
    this.getIdiomasTemplateEmailRt(this.instituto);

  }

  getInfoEmpresa(){
    this.sssv.getInfoEmpresa(this.idEmpresa).subscribe((respuesta:any) => {
      console.log("getInfoEmpresa:",respuesta);

      if(moment(respuesta.createdAt).isBefore(moment(this.fechaNuevaVersion)) ){  //si la fecha es posterior a la indicada, nueva version
        this.mostrarCloudNuevo = true;
      }
      let dateCreatProduct=localStorage.getItem('createdAtProduc');

      let validDateProduct=moment(dateCreatProduct).isAfter(moment(this.fechaPasoVoice));
      console.log(validDateProduct);
        if(validDateProduct){  //si la fecha es posterior a la indicada, mostrar control
          this.mostrarConfigVoiceSection = true;
        }else{
          this.mostrarConfigVoiceSection = false;

        }
    });
  }

  obtieneBanderasConfiguracion(){
    this.ees.getFlagsConfig(this.idEmpresa,this.idProducto).subscribe((respuesta:any) => {
      console.log("getFlags:",respuesta);
      if(respuesta.success){
        this.datosBanderas = respuesta;
        delete this.datosBanderas.success;
      }
    });
  }

  guardaCambiosBanderas(){
    this.ees.setFlagsConfig(this.datosBanderas, this.idEmpresa, this.idProducto).subscribe((respuesta:any) => {
      console.log("setFlagsConfig:",respuesta);
      if(respuesta.success){
        //this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_OP1_ON')
        this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.SAVED_CHANGES'), "", {
          duration: 2000,
        });
        // this._snackBar.open(this.translateSrv.instant('EDITOR.CONFIGADICIONAL.SAVEOK'), "OK", {
        //   duration: 2000,
        //   horizontalPosition: "center",
        //   verticalPosition: "bottom",
        //   panelClass: ['background-red']
        // });
      }
    });
  }

  guardaCambiosConfigVoiceSection(event:any){
    let datos={productoId:this.idProducto,configVoiceSection:event.checked}
    this.sssv.setConfigVoiceSection(this.idEmpresa, datos).subscribe((respuesta:any) => {
      console.log("setFlagsConfig:",respuesta);
      this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.SAVED_CHANGES'), "", {
        duration: 2000,
      });

    });
  }

  getTextoCertificado(surveyToken:string){
    this.ees.getTextoCertificado(surveyToken).subscribe((respuesta:any) => {
      console.log("getTextoCertificado:",respuesta);
      if(respuesta.success){
        this.textoCertificado = respuesta.result.oMultiSiteString
      }
    });
  }

  async editarTextoCertificado(){
    const { value: textoCertificado } = await Swal.fire({
      title: this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.CUSTOM_TEXT.TITULO'),
      input: 'textarea',
      inputLabel: this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.CUSTOM_TEXT.SUBTITULO'),
      inputPlaceholder: this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.CUSTOM_TEXT.HINT'),
      showCancelButton: true,
      allowOutsideClick: false,
      width: '40%',
      confirmButtonText: this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.CUSTOM_TEXT.OK'),
      cancelButtonText: this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.CUSTOM_TEXT.CANCEL'),
      reverseButtons: true,
      inputValue: this.textoCertificado
    })

    if (textoCertificado) {
      // Swal.fire(textoCertificado)
      const datos = {
        productoId: this.idProducto,
        certification_key_text: textoCertificado
      };
      this.ees.actualizaTextoCertificado(this.idEmpresa, datos).subscribe((respuesta:any) => {
        console.log("actualizaTextoCertificado:",respuesta);
        this.textoCertificado = textoCertificado;
        this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.CUSTOM_TEXT.SAVED_CHANGES'), "", {
          duration: 2000,
        });
      });
    }
  }


  getBanderaConfiguracion(){
    this.programacionService.getVariablesConfiguracionProducto(this.idEmpresa,this.idProducto).subscribe((respuesta:any) => {
      console.log("respuesta:",respuesta);
      if(respuesta.success == true){

        let requerimientosv3:any={};
        this.activarProrroga=respuesta.activarProrroga;
        this.actualizarFechaCierre = respuesta.actualizarFechaCierre;
        this.companyName4All = respuesta.companyName4All;
        this.controlFlag = respuesta.controlFlag;
        this.correosCierre = respuesta.correosCierre;
        this.correosEnviados = respuesta.correosEnviados;
        this.desbloqueoPasos = respuesta.desbloqueoPasos;
        this.edicion = respuesta.edicionTemplates;
        this.edicionTemplates = respuesta.edicionTemplates;
        this.editarCierre=respuesta.editarCierre;
        this.activePing = respuesta.isPin;
        this.isPin = respuesta.isPin;
        this.validacionReq=!respuesta.requerimientos; ///****checar esta variable
        this.requerimientos=!respuesta.requerimientos;
        this.requerimientosv3= respuesta.requerimientosv3; /////objeto
        this.mailRequerimientosv3 = respuesta.mailRequerimientosv3; //variable certificar 3.0
        if (this.instituto==1 && !respuesta.resultsBoxEntregables && !respuesta.resultsBoxRanking) {
          this.resultsBoxEntregables = true;
          this.resultsBoxRanking = true;


        }else if(this.instituto==1 && respuesta.resultsBoxEntregables && !respuesta.resultsBoxRanking) {
          this.resultsBoxEntregables = true;
          this.resultsBoxRanking = true;
        }else if (this.instituto==1 && !respuesta.resultsBoxEntregables && respuesta.resultsBoxRanking) {
          this.resultsBoxEntregables = true;
          this.resultsBoxRanking = true;
        }else{
          console.log("entro este visne ");
          this.resultsBoxEntregables = respuesta.resultsBoxEntregables;
          this.resultsBoxRanking = respuesta.resultsBoxRanking;
        }
        this.showInstructions=respuesta.showInstructions;
        this.showHelp=respuesta.showHelp;
        this.showUserName=respuesta.showUserName;
        this.validadoTemplates = respuesta.validadoTemplates;



      }

    },error=>{
      console.log(error);
    });

  }

  actualizarBanderaConfiguracion(event:any,tipo:any){
    let datos:any={};
    let texto:any;
   switch (tipo) {
     case 'controlFlag':
     datos={
       activarProrroga:this.activarProrroga,
       actualizarFechaCierre:this.actualizarFechaCierre,
       companyName4All:this.companyName4All,
       controlFlag: event.checked,
       correosCierre :this.correosCierre,
       correosEnviados :this.correosEnviados,
       desbloqueoPasos :this.desbloqueoPasos,
       edicionTemplates:this.edicionTemplates,
       editarCierre: this.editarCierre,
       isPin :this.isPin,
       mailRequerimientosv3: this.mailRequerimientosv3,
       requerimientos: this.requerimientos,
       requerimientosv3:this.requerimientosv3,
       resultsBoxEntregables: this.resultsBoxEntregables,
       resultsBoxRanking:this.resultsBoxRanking,
       validadoTemplates:this.validadoTemplates,
       showInstructions:this.showInstructions,
       showHelp:this.showHelp,
       showUserName:this.showUserName,
     }
     if (event.checked==true) {
        texto='CONSULTATABLA.EDITORMAILODS.MODAL_PRECONTROL_ON'
      }else{
        texto='CONSULTATABLA.EDITORMAILODS.MODAL_PRECONTROL_OFF'
      }
       break;
       case 'cajaIns':
       datos={
         activarProrroga:this.activarProrroga,
         actualizarFechaCierre:this.actualizarFechaCierre,
         companyName4All:this.companyName4All,
         controlFlag: this.controlFlag,
         correosCierre :this.correosCierre,
         correosEnviados :this.correosEnviados,
         desbloqueoPasos :this.desbloqueoPasos,
         edicionTemplates:this.edicionTemplates,
         editarCierre: this.editarCierre,
         isPin :this.isPin,
         mailRequerimientosv3: this.mailRequerimientosv3,
         requerimientos: this.requerimientos,
         requerimientosv3:this.requerimientosv3,
         resultsBoxEntregables: this.resultsBoxEntregables,
         resultsBoxRanking:this.resultsBoxRanking,
         validadoTemplates:this.validadoTemplates,
         showInstructions:event.checked,
         showHelp:this.showHelp,
         showUserName:this.showUserName,
       }
       if (event.checked==true) {
          texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP14_ON'
        }else{
          texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP14_OFF'
        }
         break;
       case 'cajaAyu':
       datos={
         activarProrroga:this.activarProrroga,
         actualizarFechaCierre:this.actualizarFechaCierre,
         companyName4All:this.companyName4All,
         controlFlag: this.controlFlag ,
         correosCierre :this.correosCierre,
         correosEnviados :this.correosEnviados,
         desbloqueoPasos :this.desbloqueoPasos,
         edicionTemplates:this.edicionTemplates,
         editarCierre: this.editarCierre,
         isPin :this.isPin,
         mailRequerimientosv3: this.mailRequerimientosv3,
         requerimientos: this.requerimientos,
         requerimientosv3:this.requerimientosv3,
         resultsBoxEntregables: this.resultsBoxEntregables,
         resultsBoxRanking:this.resultsBoxRanking,
         validadoTemplates:this.validadoTemplates,
         showInstructions:this.showInstructions,
         showHelp:event.checked,
         showUserName:this.showUserName,
       }
       if (event.checked==true) {
          texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP15_ON'
        }else{
          texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP15_OFF'
        }
         break;
       case 'cajaUser':
       datos={
         activarProrroga:this.activarProrroga,
         actualizarFechaCierre:this.actualizarFechaCierre,
         companyName4All:this.companyName4All,
         controlFlag: this.controlFlag ,
         correosCierre :this.correosCierre,
         correosEnviados :this.correosEnviados,
         desbloqueoPasos :this.desbloqueoPasos,
         edicionTemplates:this.edicionTemplates,
         editarCierre: this.editarCierre,
         isPin :this.isPin,
         mailRequerimientosv3: this.mailRequerimientosv3,
         requerimientos: this.requerimientos,
         requerimientosv3:this.requerimientosv3,
         resultsBoxEntregables: this.resultsBoxEntregables,
         resultsBoxRanking:this.resultsBoxRanking,
         validadoTemplates:this.validadoTemplates,
         showInstructions:this.showInstructions,
         showHelp:this.showHelp,
         showUserName:event.checked,
       }

       if (event.checked==true) {
          texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP16_ON'
        }else{
          texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP16_OFF'
        }
         break;
        case 'entre':
        datos={
          activarProrroga:this.activarProrroga,
          actualizarFechaCierre:this.actualizarFechaCierre,
          companyName4All:this.companyName4All,
          controlFlag: this.controlFlag ,
          correosCierre :this.correosCierre,
          correosEnviados :this.correosEnviados,
          desbloqueoPasos :this.desbloqueoPasos,
          edicionTemplates:this.edicionTemplates,
          editarCierre: this.editarCierre,
          isPin :this.isPin,
          mailRequerimientosv3: this.mailRequerimientosv3,
          requerimientos: this.requerimientos,
          requerimientosv3:this.requerimientosv3,
          resultsBoxEntregables: event.checked,
          resultsBoxRanking:this.resultsBoxRanking,
          validadoTemplates:this.validadoTemplates,
          showInstructions:this.showInstructions,
          showHelp:this.showHelp,
          showUserName: this.showUserName,
        }

        if(event.checked==true){
              texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP11_ENTREGABLES_ON'
          }
        else{
             texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP11_ENTREGABLES_OFF'
        }
        break;

        case 'ranki':
        datos={
          activarProrroga:this.activarProrroga,
          actualizarFechaCierre:this.actualizarFechaCierre,
          companyName4All:this.companyName4All,
          controlFlag: this.controlFlag ,
          correosCierre :this.correosCierre,
          correosEnviados :this.correosEnviados,
          desbloqueoPasos :this.desbloqueoPasos,
          edicionTemplates:this.edicionTemplates,
          editarCierre: this.editarCierre,
          isPin :this.isPin,
          mailRequerimientosv3: this.mailRequerimientosv3,
          requerimientos: this.requerimientos,
          requerimientosv3:this.requerimientosv3,
          resultsBoxEntregables: this.resultsBoxEntregables,
          resultsBoxRanking: event.checked,
          validadoTemplates:this.validadoTemplates,
          showInstructions:this.showInstructions,
          showHelp:this.showHelp,
          showUserName: this.showUserName,
        }
        if(event.checked==true){
             texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP11_RANKING_ON'
           }
           else{
            texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP11_RANKING_OFF'
           }

        break;

     default:
       break;
   }
    console.log('datos',datos);
    this.programacionService.actualizaVariablesConfiguracionProducto(this.idEmpresa,this.idProducto,datos).subscribe((respuesta:any) => {
      console.log("respuesta:",respuesta);
          this._snackBar.open(this.translateSrv.instant(texto), "", {
            duration: 2000,
          });
      this.getBanderaConfiguracion();
    },error=>{
      console.log(error);
    });
  }

  cambiaPaso(numero:number){
    console.log("paso:",numero);

    this.pasos.selectedIndex = numero;
    if(numero == 0){
      this.enviaInfoCorreos(true);
    }
  }

  enviaInfoEditor(datos:any) {
    this.enviaDatosEditor.next(datos);
  }

  enviaInfoCorreos(datos:any) {
    this.enviaDatosCorreos.next(datos);
  }

  regresarDetail(){
    this.router.navigate(['/companies/detail',this.idEmpresa]);
  }

  getStatusEditor(){
    this.programacionService.getStatusEditor(this.idEmpresa,this.idProducto).subscribe((respuesta:any) => {
      this.statusEdtitor=true;
      console.log("respGetStatusEd:",respuesta);
      if(respuesta.message == "Success"){
        this.edicion = respuesta.edicionTemplates;
        this.validacion = respuesta.saltarValidado;
      }
    },error=>{
      console.log(error);
    });
  }

  getCierreActivo(){
    this.programacionService.getCierreActivo(this.idEmpresa,this.idProducto).subscribe((respuesta:any) => {
      console.log("getCierreActivo:",respuesta);
      if(respuesta.success){
        this.numeroRecos = respuesta.totalRecordatorios;
        this.cierreActivado = respuesta.actualizarFechaCierre;
      }
    },error=>{
      console.log(error);
    });
  }

  getStatusValidacionEncuesta(){
    this.programacionService.getvalidacionEncuestaRequeridaFocusArea(this.idEmpresa,this.idProducto).subscribe((respuesta:any) => {
      this.statusProrroga=true;
      console.log("Bandera:",respuesta);
      this.validacionEncuesta= respuesta.validacion;
    },error=>{
      console.log(error);
    });
  }

actualizaStatusValidacionEncuesta(event:any){
  console.log(event);

  let datos:any = {
    validacion : event.checked
  };
  this.programacionService.validacionEncuestaRequeridaFocusArea(this.idEmpresa,this.idProducto,datos).subscribe((respuesta:any) => {
    console.log("se actualizo: ",respuesta);


  },error=>{
    console.log(error);
  });
}

  setStatusEditor(event:any, opcion:number){
    let datos:any = {
      productoId: this.idProducto
    };
    switch (opcion) {
      case 1: this.edicion = event.checked; datos.edicion = event.checked; datos.saltarValidado = this.validacion; break;
      case 2: this.validacion = event.checked; datos.saltarValidado = event.checked; datos.edicion = this.edicion; break;
    }
    console.log("datosSetSt:",datos);
    this.programacionService.setStatusEditor(this.idEmpresa,datos).subscribe((respuesta:any) => {
      console.log("respSetStEd:",respuesta);
      if(respuesta.message == "Success"){
        this.getBanderaConfiguracion();
        if(opcion == 1 && this.edicion){
          this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_OP1_ON'), "", {
            duration: 2000,
          });
        }
        if(opcion == 2 && this.validacion){
          this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_OP2_ON'), "", {
            duration: 2000,
          });
        }
      }
    },error=>{
      console.log(error);
    });
  }

  setStatusCierre(event:any, opcion:number){
    let datos:any = {
      productoId: this.idProducto
    };
    switch (opcion) {
      case 1: datos.bandera = this.cierreActivado; datos.totalRecordatorios = this.numeroRecos; break;
      case 2: this.cierreActivado = event.checked; datos.bandera = event.checked; datos.totalRecordatorios = this.numeroRecos; break;
    }
    console.log("datosSetSt:",datos);
    this.programacionService.setCierreActivo(this.idEmpresa,datos).subscribe((respuesta:any) => {
      console.log("respSetCierre:",respuesta);
      if(respuesta.success){
        this.getBanderaConfiguracion();
        if(opcion == 1){
          this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_OP7_ON'), "", {
            duration: 2000,
          });
        }
        if(opcion == 2){
          if(this.cierreActivado){
            this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_OP8_ON'), "", {
              duration: 2000,
            });
          }
          else{
            this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_OP8_OFF'), "", {
              duration: 2000,
            });
          }
        }
      }
    },error=>{
      console.log(error);
    });
  }

  statusDesbloqueo(){
    this.encuestaService.estatusDesbloqueoPasos(this.idEmpresa,this.idProducto).subscribe((respuesta:any) => {
      console.log("respDesbloqueo:",respuesta);
      if(respuesta.desbloqueo==true){
        this.desbloqueoActivar=true;
      }
      else{
        this.desbloqueoActivar=false;
      }
    },error=>{
      console.log(error);
    });
  }

  activarDesbloqueoPasos(event:any){
    let datos:any = {
      desbloqueoPasos: event.checked
    };
    // this.desbloqueoActivar=true;
    this.encuestaService.activarDesbloqueoPasos(this.idEmpresa,this.idProducto,datos).subscribe((respuesta:any) => {
      console.log("respDesbloqueo:",respuesta);
      if(respuesta.success==true){
        this.getBanderaConfiguracion();
        if(event.checked==true){
          this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_OP11_ON'), "", {
            duration: 2000,
          });
        }
        else{
          this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_OP12_OF'), "", {
            duration: 2000,
          });
        }
      }
    },error=>{
      console.log(error);
    });
  }


  getStatusBanderaProrrogas(){
    console.log("tipo de producto "+this.tipoProducto);
    this.programacionService.getStatusBanderaProrroga(this.idEmpresa,this.idProducto).subscribe((respuesta:any) => {
      this.statusProrroga=true;
      console.log("respuesta:",respuesta);
      // if(respuesta.message == "Success"){
      this.activarProrroga=respuesta.activarProrroga;
      this.editarCierre=respuesta.editarCierre;
      // }
    },error=>{
      console.log(error);
    });
  }
  activePing:boolean;
  getStatusPing(){
    console.log("tipo de producto "+this.tipoProducto);
    if(this.tipoProducto != 'Focus Area'){
      this.programacionService.getStatusPing(this.idEmpresa,this.idProducto).subscribe((respuesta:any) => {
        console.log("Respuesta pin");
        console.log(respuesta.success);
        if(respuesta.success){
          this.activePing=respuesta.isPin;
        }
      },error=>{
        console.log(error);
      });
    }

  }

  activarPing(event:any){
    let datos:any = {
      bandera: !this.activePing
    };
    console.log(datos);
    this.programacionService.actualizarPing(this.idEmpresa,this.idProducto,datos).subscribe((respuesta:any) => {
      console.log("respuesta");
      console.log(respuesta.success);
      if(respuesta.success){
        this.getBanderaConfiguracion();
        this.activePing=respuesta.isPin;
        if(this.activePing){
          this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_PIN_ON'), "", {
            duration: 2000,
          });
        }else{
          this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_PIN_OFF'), "", {
            duration: 2000,
          });
        }

      }
      //
    },error=>{
      console.log(error);
    });
  }
  actualizarBanderasProrrogas(event:any,opcion:number){
    let datos1:any = {};
    switch (opcion) {
      case 1:
       this.editarCierre = event.checked;
       datos1.editarCierre = event.checked;
       datos1.activarProrroga = this.activarProrroga;
       break;
      case 2:
      this.activarProrroga = event.checked;
      datos1.activarProrroga = event.checked;
      datos1.editarCierre = this.editarCierre;
      break;
    }
    console.log(datos1);
    this.programacionService.actualizaStatusBanderaProrroga(this.idEmpresa,this.idProducto,datos1).subscribe((resp:any) => {
      console.log("se actualizaron",resp);
      if (opcion==2) {
        if (!event.checked) {
          this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_OP6_OFF'), "", {
            duration: 2000,
          });
        }else{
          this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_OP6_ON'), "", {
            duration: 2000,
          });

        }
      }
      this.getStatusBanderaProrrogas();
      this.getBanderaConfiguracion();
    },error=>{
      console.log(error);
    });

  }

  status_req(event:any){
      let data = {
        productoId: this.idProducto_tmp
      }
      this.sheduleService.setBandera_req(this.idEmpresa,data).subscribe((response:backInter.RespuestaGen) => {
        console.log(response);
        if(response.success){
          this.validacionReq=!this.validacionReq;
          this.velidateBanderas(1);
          this.getBanderaConfiguracion();
          this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.OPCION_7'), "", {
            duration: 2000,
          });
        }
        //this.velidateBanderas(1);
      }, error => {
        console.log(error);
      });

  }

  velidateBanderas(bandera?:any){
    let datos = {
      productoId: this.idProducto_tmp
    };
    this.sheduleService.getBanderas_req(this.idEmpresa,datos).subscribe((respuesta:backInter.statusReqTec) => {
          console.log("Validate bandera",respuesta);
        if(respuesta.success){
          this.validacionReq=!respuesta.requerimientos;
          if(bandera==1){
            this._snackBar.open(this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.OPCION_7'), "", {
              duration: 2000,
            });
          }
        }
    }, error => {
      console.log(error);
    });
  }

  // statusMostrarResuCerti(){
  //   if(this.tipoProducto == "Certify"){
  //     this.encuestaService.estatusMostrarCajasCerPortal(this.idEmpresa,this.idProducto).subscribe((respuesta:any) => {
  //       console.log("resultsBox:",respuesta);
  //       this.resultsBoxRanking=respuesta.resultsBoxRanking;
  //       this.resultsBoxEntregables=respuesta.resultsBoxEntregables;
  //       // if(respuesta.resultsBoxRanking==true){
  //       //   this.CaResulCertiRanking=true;
  //       //   this.CaResulCertiE=true;
  //       // }
  //       // else{
  //       //   this.CaResulCertiRanking=false;
  //       //   this.CaResulCertiE=false;
  //       // }
  //     },error=>{
  //       console.log(error);
  //     });
  //   }
  //
  // }

  // activarMostrarResuCerti(event:any,tipo){
  //   console.log("tipo: ",tipo);
  //   let texto:string;
  //   let datos:any ={}
  //   switch (tipo) {
  //     case 'entre':
  //     datos={
  //       resultsBoxEntregables: event.checked, resultsBoxRanking: this.resultsBoxRanking
  //     };
  //     if(event.checked==true){
  //       texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP11_ENTREGABLES_ON'
  //     }
  //     else{
  //      texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP11_ENTREGABLES_OFF'
  //     }
  //
  //       break;
  //     case 'ranki':
  //   datos= {
  //       resultsBoxRanking: event.checked, resultsBoxEntregables: this.resultsBoxEntregables
  //     };
  //     if(event.checked==true){
  //       texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP11_RANKING_ON'
  //     }
  //     else{
  //      texto='CONSULTATABLA.EDITORMAILODS.MODAL_OP11_RANKING_OFF'
  //     }
  //       break;
  //
  //     default:
  //       break;
  //   }
  //   console.log("datos ", datos);
  //     this.encuestaService.activarMostrarCajasCerPortal(this.idEmpresa,this.idProducto,datos).subscribe((respuesta:any) => {
  //     console.log("resultsBox:",respuesta);
  //     this.statusMostrarResuCerti();
  //     if(respuesta.success==true){
  //         this._snackBar.open(this.translateSrv.instant(texto), "", {
  //           duration: 2000,
  //         });
  //     }
  //   },error=>{
  //     console.log(error);
  //   });
  // }


async sendEmailRequerimientosTecnicos(){
  let textSendEmail='CONSULTATABLA.SEN_EMAIL_REQ_PROD';
  let btnSi='CONSULTATABLA.REQ.BTNSI';
  let btnNo='CONSULTATABLA.REQ.BTNNO';

  this.translate.get(textSendEmail).subscribe((res: string) => { textSendEmail = res; });
  this.translate.get(btnSi).subscribe((res: string) => { btnSi = res; });
  this.translate.get(btnNo).subscribe((res: string) => { btnNo = res; });
  const fruit:any = await Swal.fire({
    title: textSendEmail,
    text: this.translate.instant('CONSULTATABLA.EMAIL_REQ_INTRO'),
    input: 'select',
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: btnSi,
    cancelButtonText: btnNo,
    inputOptions: this.idiomasRTSelect,
    inputPlaceholder: this.translate.instant('CONSULTATABLA.EMAIL_REQ_PLACE'),
    inputValidator: (value) => {
      console.log("value",value);

      return new Promise((resolve) => {
        if (value != '') {
          let datos={lang:value}
          this.modalSendEmail();
          this.encuestaService.sendEmailReqTecnicos(this.idEmpresa,this.idProducto,datos).subscribe((response:any) => {
            if (response.message=='IT Manager Not Found') {
              Swal.fire({
                title: this.translate.instant('MODALES.ERRORES.IT Manager Not Found'),
                icon: "error",
                confirmButtonColor: '#e40601'
              });
            }else{

              this.getBanderaConfiguracion();
            }
            Swal.close();
          }, error => {
            console.log(error);
          });
          resolve('');
        } else {
          let erro=this.translate.instant('CONSULTATABLA.WARN_SEN_EMAIL_REQ_PROD')
          resolve(erro);
        }
      })
    }
  })

}


 getIdiomasTemplateEmailRt(instituto){
   this.encuestaService.getIdiomasTemplateEmailRT(instituto,1).subscribe((response:any) => {
console.log("response",response);
let idiomasRT:any={};
     response.correos_CGO.forEach(idioma => {
       if (idiomasRT[idioma.lang]==undefined) {
         idiomasRT[idioma.lang]=this.translate.instant('SELECTOR.'+idioma.lang);
       }
     });
console.log('Idioma arreglo', idiomasRT);
this.idiomasRTSelect=idiomasRT;

   }, error => {
     console.log(error);
   });
 }


modalSendEmail(){
  let textSendEmail='CONSULTATABLA.SEN_EMAIL_MODAL';
  this.translate.get(textSendEmail).subscribe((res: string) => { textSendEmail = res; });
   // this.translate.get('CERTIFICAR.FORALL.CARGANDO_PRACTICA').subscribe((res: string) => { mensaje = res; });

  Swal.fire({
    imageUrl:this.urlAssetsEmail+'platform/img/tenor.gif',
    title: textSendEmail,
    allowOutsideClick: false,
    imageWidth: 100,
    imageHeight: 90,
    showConfirmButton:false

  });
}

  versionNuevaCloud(){

  }

}
